import React from 'react';

const SelectedPassageRow = ({label, value, title = false, titleLabel}) => {
    return (
        <>
            {
                title ?
                    <tr className="border-b border-t border-[#dcdcdc]">
                        <td colSpan="2" className="detail-table-key text-center font-bold text-base py-2">
                            <b>{titleLabel}</b>
                        </td>
                    </tr>
                    :
                    <tr className="border-b border-[#dcdcdc]">
                        <td className="detail-table-key py-2 px-1">{label}</td>
                        <td className="detail-table-value py-2 px-1">{value}</td>
                    </tr>
            }
        </>
    );
};

export default SelectedPassageRow;